import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { MITPService } from "./mitp.service";
import { Icon } from "../entities/icon";
import { NavigationSpecialtyItem } from "../interfaces/navigation-specialty-item";

@Injectable({
	providedIn: "root",
})
export class NavigationSpecialtyService {
	private http = inject(HttpClient);
	private mitp = inject(MITPService);

	private navigationItems: NavigationSpecialtyItem[] = [];

	setNavigationItems(items: NavigationSpecialtyItem[]): void {
		this.navigationItems = items;
	}

	getNavigationItems(): NavigationSpecialtyItem[] {
		return this.navigationItems;
	}

	addIcon(icon: Icon): Observable<null> {
		return this.http.post<any>(this.mitp.Icons(), icon);
	}

	getIcons(): Observable<Icon[]> {
		return this.http.get<Icon[]>(this.mitp.Icons());
	}

	getProtocolNavigationItems(instituteId: number): Observable<NavigationSpecialtyItem[]> {
		return this.http.get<NavigationSpecialtyItem[]>(
			this.mitp.Institutes() + `/${instituteId}/navigation/specialties`
		);
	}

	getMyNavigationItems(): Observable<NavigationSpecialtyItem[]> {
		return this.http.get<NavigationSpecialtyItem[]>(this.mitp.Institutes() + `/navigation/specialties`);
	}

	getMyProtocolNavigationItems(): Observable<NavigationSpecialtyItem[]> {
		return this.http.get<NavigationSpecialtyItem[]>(this.mitp.Institutes() + `/navigation/specialties`);
	}

	createProtocolNavigationSpecialty(
		instituteId: number,
		item: NavigationSpecialtyItem
	): Observable<HttpResponse<NavigationSpecialtyItem>> {
		return this.http.post<NavigationSpecialtyItem>(
			this.mitp.Institutes() + `/${instituteId}/navigation/specialties`,
			item,
			{
				observe: "response",
			}
		);
	}

	deleteProtocolNavigationSpecialtyItem(item: NavigationSpecialtyItem): Observable<HttpResponse<null>> {
		return this.http.delete<null>(
			this.mitp.Institutes() + `/${item.institute.id}/navigation/specialties/${item.id}`,
			{
				observe: "response",
			}
		);
	}
}
